import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  account: undefined,
  accounts: [],
  initialFilters: {
    page: 0,
    recordsPerPage: { label: 20, value: 20 },
  },
};

export const AccountManagementSlice = createSlice({
  name: 'accountManagement',
  initialState,
  reducers: {
    setAccount: (state, action) => {
      state.account = action.payload;
    },
    setAccounts: (state, action) => {
      state.accounts = action.payload;
    },
    setInitialFilters: (state, action) => {
      state.initialFilters = action.payload;
    },
    resetAccountManagementSlice: () => initialState,
  },
});

export const { setAccount, setAccounts, setInitialFilters, resetAccountManagementSlice } =
  AccountManagementSlice.actions;

export default AccountManagementSlice.reducer;
